import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useDisclosure, Box, Flex, Icon, Text } from '@chakra-ui/react';
import { Modal, Toggle } from '../../../components';
import { Bell } from '../../../assets';

interface DonationsNotificationsModalProps {
  receiveNotifications: boolean;
  onToggle: (checked: boolean) => void;
  onClosed: () => void;
  isOpen: boolean;
}

export const DonationsNotificationsModal: FC<
  DonationsNotificationsModalProps
> = (props: DonationsNotificationsModalProps) => {
  const { receiveNotifications, onToggle, onClosed, isOpen } = props;

  const [internalIsOpen, setInternalIsOpen] = useState(isOpen);

  useEffect(() => {
    setInternalIsOpen(isOpen);
  }, [isOpen]);

  const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.currentTarget;
    onToggle(checked);
  };
  const { onClose } = useDisclosure();
  const close = () => {
    setInternalIsOpen(false);
    onClose();
    onClosed();
  };

  return (
    <Modal
      isOpen={internalIsOpen}
      onClose={close}
      size="xs"
      trackingLabel="donationNotification"
      modalTitle={
        <Box mt="0" pt="0">
          <Flex>
            <Icon as={Bell} mr="1rem" mt="0.25rem" />
            <Text fontSize="lg">Donation Notifications</Text>
          </Flex>
        </Box>
      }
    >
      <Box>
        <Toggle
          status={receiveNotifications}
          label="Receive an email when a donation is made."
          onChange={(e) => handleToggle(e)}
        />
      </Box>
    </Modal>
  );
};
